import About from "components/about/About"

export default About